var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{staticStyle:{"height":"320px","width":"100%"},attrs:{"options":_vm.chartOptionsMerma}})
}
var staticRenderFns = []

export { render, staticRenderFns }